<template>
  <div>
    <div class="panel-heading">
      <h4 class="panel-title">Invoices</h4>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <preDatatableComponent
          :removeAddButton="true"
          :removeWarehouseDeliverButton="true"
          :tableData="tableData"
          :resetGetResults="resetGetResults"
          :resetGetResults2="resetGetResults2"
          :searchMe="searchMe"
          :pagination="pagination"
          :perPageFix="perPageFix"
          :filterTable="filterTable"
          :hideSelectingColumn="true"
        ></preDatatableComponent>
        <div class="col-xs-12">
          <div class="row text-center">
            <span
              id="test-editable"
              style="opacity:0"
            ></span>
          </div>

          <datatable
            v-if="!isMobile"
            :sortDir="tableData.sortDir"
            :columns="columns"
            :sortByColumn="sortByColumn"
            :searchOneCol="searchOneCol"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.credit_invoice_id"
              >
                <td>{{ r.invoice_number }}</td>
                <td v-if="r.credit_invoice_date != null">{{ r.credit_invoice_date }}</td>
                <td v-else>{{ r.created_at }}</td>
                <td v-if="r.credit_status === 'add'">
                  <template v-if="r.payment_method == 'fib'">
                    Adding Balance with FIB
                  </template>
                  <template v-else-if="r.payment_method == 'fastpay'">
                    Adding Balance with FastPay
                  </template>
                  <template v-else>
                    Adding Balance from ShipZone Office
                  </template>
                </td>
                <td v-if="r.credit_status === 'cash back'">
                  Returning Balance from ShipZone Office
                </td>
                <td v-if="r.credit_status === 'add'">
                  <span class="label bg-green-600"> {{ r.credit_status }}</span>
                </td>
                <td v-if="r.credit_status === 'cash back'">
                  <span class="label bg-orange-600"> {{ r.credit_status }}</span>
                </td>
                <td>${{ r.amount }}</td>
                <td style="font-size: 14px; padding-left: 5px;">
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showApp', r.credit_invoice_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>
              <tr style="height: 90px;">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style="float: right; text-align: right; font-size: 14px; font-weight: bold; padding-top: 10px">
                  Total Add:
                  <span style="padding-left: 10px">${{ calculationResults.total_add }}</span> <br />
                  Total CashBack: &nbsp;<span style="padding-left: 10px">${{ calculationResults.total_cash_back }}</span>
                  <br />
                  General Total:
                  <span style="padding-left: 10px">${{ calculationResults.total }}</span>
                </td>
              </tr>
              <tr id="no-result-row">
                <td
                  :colspan="columns.length"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </datatable>

          <mobile-datatable
            v-if="isMobile"
            :isOrder="true"
          >
            <tbody>
              <tr
                v-for="r in apiResults"
                :key="r.order_id"
              >
                <td>
                  Invoice No. : {{ r.invoice_number }} , <br />
                  <span v-if="r.credit_status === 'add'">
                    Adding Balance from ShipZone Office
                  </span>
                  <span v-if="r.credit_status === 'cash back'">
                    Returning Balance from ShipZone Office
                  </span>
                </td>
                <td>
                  <span v-if="r.credit_status === 'add'">
                    <span class="label bg-green-600"> {{ r.credit_status }}</span>
                  </span>
                  <span v-if="r.credit_status === 'cash back'">
                    <span class="label bg-orange-600"> {{ r.credit_status }}</span>
                  </span>
                  &nbsp; ${{ r.amount }} <br />
                  <span v-if="r.credit_invoice_date != null">{{ r.credit_invoice_date }}</span>
                  <span v-else>{{ r.created_at }}</span>
                  <br />
                  <a
                    style="color:#424242"
                    tooltip="View Invoice"
                    @click="initDetail('modal_showApp', r.credit_invoice_id)"
                  >
                    <i class="material-icons">assignment</i>
                  </a>
                </td>
              </tr>

              <tr>
                <td style="font-size: 14px; font-weight: bold;">
                  Total Add
                </td>
                <td style="font-size: 14px; font-weight: bold;">
                  ${{ calculationResults.total_add }}
                </td>
              </tr>
              <tr>
                <td style="font-size: 14px; font-weight: bold">
                  Total CashBack
                </td>
                <td style="font-size: 14px; font-weight: bold">
                  ${{ calculationResults.total_cash_back }}
                </td>
              </tr>
              <tr>
                <td style="font-size: 14px; font-weight: bold;">
                  General Total
                </td>
                <td style="font-size: 14px; font-weight: bold;">${{ calculationResults.total }}</td>
              </tr>
              <tr id="no-result-row">
                <td
                  colspan="2"
                  class="text-center"
                >
                  <v-alert
                    type="error"
                    :value="alertValue"
                  >
                    No Results Found
                  </v-alert>
                </td>
              </tr>
            </tbody>
          </mobile-datatable>

          <view-action-log
            :detailData="detailData"
            :closeModal="closeModal"
            :companyData="companyData"
          ></view-action-log>

          <hr />
          <div class="row">
            <div class="col-xs-12 text-right">
              <paginate
                :page-count="pagination.lastPage"
                :page-range="2"
                :changePage="changePage"
                :container-class="'pagination'"
                :pagination="pagination"
                :page-class="'page-item'"
              >
              </paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationVue from '../Pagination.vue'
import preDatatableComponent from '../preDatatableComponent.vue'
import DatatableVue from '../Datatable.vue'
import viewActionLog from '../logs/viewActionLog.vue'
import mobileDatatable from '../mobileDatatable'
import axios from 'axios'
import swal from 'sweetalert'

export default {
  components: {
    preDatatableComponent: preDatatableComponent,
    datatable: DatatableVue,
    paginate: PaginationVue,
    'view-action-log': viewActionLog,
    'mobile-datatable': mobileDatatable
  },
  created() {
    this.getLoggedInUser()
    this.getResults()
    this.getCalculation()

    if (screen.width <= 600) {
      this.isMobile = true
    } else {
      this.isMobile = false
    }
  },
  mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }
    this.perPageFix()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    let sortOrders = {}
    let columns = [
      { label: 'Invoice No', sortable: true, searchable: true, name: 'invoice_number' },
      { label: 'Date', sortable: true, searchable: true, name: 'credit_invoice_date' },
      { label: 'Description', sortable: true, searchable: true, name: 'description' },
      { label: 'Action', sortable: true, searchable: true, name: 'credit_status' },
      { label: 'Amount', sortable: true, searchable: true, name: 'amount' }
    ]
    columns.forEach(column => {
      sortOrders[column.name] = -1
    })

    return {
      isMobile: false,
      loader: null,
      loading: false,
      url: 'api/customer_credit_invoice',
      logDetailUrl: 'api/credit_log_actions',
      calculationUrl: 'api/customer_action_calculation',
      invoiceUrl: 'api/customer_last_invoice',
      companyUrl: 'api/company_info',
      rowIndex: '',
      alertValue: false,
      checkAlert: false,
      btnsave: true,
      loggedInUserData: {},
      companyData: {
        company_name: '',
        company_address: '',
        company_email: ''
      },
      detailData: {
        credit_invoice_id: '',
        invoice_number: '',
        description: '',
        action: '',
        created_at: '',
        amount: '',
        note: '',
        credit_log_action_date: ''
      },
      prevSearchQuery: '',
      apiResults: [],
      calculationResults: {},
      detailResults: [],
      columns: columns,
      sortKey: 'credit_invoice_id',
      sortOrders: sortOrders,
      tableData: {
        per_page: 10,
        search: '',
        column: 'credit_invoice_id',
        sortDir: 'desc',
        searchOneCol: '',
        searchOneVal: '',
        from_date: '',
        to_date: ''
      },
      pagination: {
        lastPage: 1,
        currentPage: 1,
        total: 1,
        lastPageUrl: '',
        nextPageUrl: '',
        prevPageUrl: '',
        from: '',
        to: ''
      }
    }
  },

  methods: {
    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
      })
    },

    getCalculation(theUrl = this.calculationUrl) {
      let token = localStorage.getItem('access_token')
      axios.get(theUrl, { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        this.calculationResults = response.data.data
      })
    },

    getResults(url = this.url) {
      var token = localStorage.getItem('access_token')
      let theDatatable = document.querySelector('.the-datatable')
      let thePanel = document.querySelector('.panel-flat')

      if (theDatatable != null) {
        theDatatable.classList.add('slide-table-out')
        thePanel.style.overflowX = 'auto'
      }

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.apiResults = data.data.data

          if (this.apiResults.length === 0) {
            this.tableData.searchOneCol = ''
            this.tableData.searchOneVal = ''
            this.tableData.search = ''
            this.alertValue = true
          } else {
            this.alertValue = false
          }
          this.configPagination(data.data)
          theDatatable.classList.remove('slide-table-out')
          setTimeout(function () {
            thePanel.style.overflowX = 'auto'
          }, 0)
        })
        .catch(errors => { })
    },

    resetGetResults() {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_invoice_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_invoice_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
      this.getCalculation()
    },

    resetGetResults2() {
      this.queryParameter = false
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      this.tableData.search = ''
      this.sortKey = 'credit_invoice_id'
      this.tableData.sortDir = 'desc'
      this.tableData.column = 'credit_invoice_id'
      this.tableData.from_date = ''
      this.tableData.to_date = ''
      this.getResults()
    },

    filterTable(fromDate, toDate) {
      this.tableData.from_date = fromDate
      this.tableData.to_date = toDate
      this.getResults()
    },

    perPageFix(perPage) {
      this.tableData.per_page = perPage
      this.getResults()
    },

    modal(modal) {
      $('#' + modal).modal({ backdrop: 'static' })
    },

    closeModal(modal) {
      this.getResults()
      let theModal = $('#' + modal)
      theModal.modal('toggle')
    },

    initDetail(modal, id) {
      let token = localStorage.getItem('access_token')
      this.getCompanyData(token)
      axios
        .get(this.invoiceUrl + '/' + id, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.detailResults = data.data

          this.detailData.credit_log_action_date = this.detailResults[0].credit_log_action_date
          this.detailData.credit_invoice_id = this.detailResults[0].credit_invoice_id
          this.detailData.invoice_number = this.detailResults[0].invoice_number
          this.detailData.description = this.detailResults[0].description
          this.detailData.action = this.detailResults[0].action
          this.detailData.the_credit_id = this.detailResults[0].the_credit_id
          this.detailData.created_at = this.detailResults[0].created_at
          this.detailData.amount = this.detailResults[0].amount
          this.detailData.staff_name = this.detailResults[0].staff_name
          this.detailData.customer_name = this.detailResults[0].customer_name
          this.detailData.customer_email = this.detailResults[0].customer_email
          this.detailData.phone_number = this.detailResults[0].customer_phone_number
          this.detailData.customer_address = this.detailResults[0].customer_address
          this.detailData.note = this.detailResults[0].note
        })
      this.modal(modal)
    },

    getCompanyData(token) {
      axios
        .get(this.companyUrl, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.companyData = response.data.data
        })
    },

    changePage(pageUrl) {
      this.url = pageUrl
      this.getResults()
    },

    searchMe(str) {
      this.tableData.searchOneCol = ''
      this.tableData.searchOneVal = ''
      if (str.trim() !== '') {
        this.tableData.search = str
        this.prevSearchQuery = str
        this.getResults()
      } else {
        swal({
          text: 'Type something to search!',
          icon: 'warning',
          dangerMode: true
        })
        if (this.prevSearchQuery !== '') {
          this.tableData.search = ''
          this.prevSearchQuery = ''
          this.getResults()
        }
      }
    },

    sortByColumn(str) {
      this.tableData.column = str
      this.tableData.sortKey = str
      this.tableData.sortDir = this.tableData.sortDir === 'desc' ? 'asc' : 'desc'
      this.getResults()
    },

    searchOneCol(columnName, str) {
      this.tableData.searchOneCol = columnName
      this.tableData.searchOneVal = str
      this.getResults()
    },

    configPagination(data) {
      this.pagination.lastPage = data.last_page
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.lastPageUrl = data.last_page_url
      this.pagination.nextPageUrl = data.next_page_url
      this.pagination.prevPageUrl = data.prev_page_url
      this.pagination.from = data.from
      this.pagination.to = data.to
    }
  }
}
</script>

<style>
@media screen and (max-width: 600px) {
  th {
    font-weight: bold;
    color: #273246;
    padding-left: 5px !important;
  }

  td {
    padding-left: 5px !important;
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
}

.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.col-xs-12 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.page-stats {
  align-items: center;
  position: relative;
  top: -8px;
  margin-right: 5px;
}

@media screen and (max-width: 767px) {
  .form-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}
</style>



// WEBPACK FOOTER //
// src/components/customer/customerCreditInvoice.vue